import { render } from "./document-crdt.vue?vue&type=template&id=471bb0eb&ts=true&lang=html"
import script from "./document-crdt.vue?vue&type=script&lang=ts"
export * from "./document-crdt.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__